import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Modal, Space, TextBody, TextHeading } from '@ally/metronome-ui'
import { useTransmit } from '../TransmitContext'

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  const history = useHistory()
  const { hostServices } = useTransmit()
  const onLogin = (): void => {
    history.push('/')
  }

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'modalView',
      pageName: 'AOS:Enroll:Create Login:You May Be Already Enrolled',
      options: { treatAsPageview: true },
    })
  }, [])

  return (
    <>
      <Space mb="md">
        <TextHeading tag="h1" size="md" tabIndex={-1} ref={headingRef}>
          You May Already Be Enrolled
        </TextHeading>
      </Space>
      <Space mb="md">
        <TextBody tag="p" size="md">
          You already have a username and password on file with us. If you
          remember your username, please log in below. If you&apos;ve forgotten
          your username, please call us at 1-877-247-2559 (ALLY). We&apos;re
          here 24/7 to help.
        </TextBody>
      </Space>
      <Button variant="primary" text="Log In" onClick={onLogin} />
    </>
  )
}

interface AlreadyEnrolledModalProps {
  onDismiss: (isOpen: boolean) => void
}

export const AlreadyEnrolledModal: React.FC<AlreadyEnrolledModalProps> = ({
  onDismiss,
}) => (
  <Modal
    content={<ModalContent />}
    ref={headingRef}
    showOnLoad
    toggleCallback={onDismiss}
  />
)
